import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class ProfileSeasonBanDeleted extends DomainEvent<DeletedEntity> {}
